import { render } from "./ShoppingList.vue?vue&type=template&id=3c993ee6&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"

import "./ShoppingList.vue?vue&type=style&index=0&id=3c993ee6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c993ee6"]])

export default __exports__